module.exports = __webpack_public_path__ + "static/media/cng-newsletter.c607400c.png";